import { render } from "./PromotionBannerAddEdit.vue?vue&type=template&id=730e589c&scoped=true&ts=true"
import script from "./PromotionBannerAddEdit.vue?vue&type=script&lang=ts"
export * from "./PromotionBannerAddEdit.vue?vue&type=script&lang=ts"

import "./PromotionBannerAddEdit.vue?vue&type=style&index=0&id=730e589c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730e589c"]])

export default __exports__